import { AuthenticatorAppSetup } from "@/components/Portal/UserAccount/Security/AuthenticatorSetup/AuthenticatorAppSetup";
import { expectedAuthTypeQueryParam } from "@/components/Portal/UserAccount/Security/TwoFactorAuthStatus";
import { portalRoutes } from "@/router/routes/portalRoutes";
import { ChangeTwoFactorAuthenticationMethod } from "@/services/model";

export const TwoFactorInitialAppSetupView = () => {
  const queryParams = new URLSearchParams();
  queryParams.set(
    expectedAuthTypeQueryParam,
    ChangeTwoFactorAuthenticationMethod.APP,
  );

  return (
    <div>
      <AuthenticatorAppSetup
        logoutOnAuthError={false}
        navigationTarget={
          portalRoutes.user.security.confirmBackupCodeReception +
          `?${queryParams.toString()}`
        }
      />
    </div>
  );
};
